export const ConnectionPill = ({ status }) => {
  const open = status === "open";
  return (
    <span data-testid="connection-status" className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-black/30 px-3 py-1 text-xs text-slate-300">
      <span className="relative flex h-2 w-2">
        {open && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${open ? "bg-emerald-400" : "bg-amber-400"}`} />
      </span>
      {open ? "Acompanhamento em tempo real ativo" : "Reconectando…"}
    </span>
  );
};
